export default {
  namespaced: true,
  state: () => ({
    harvests: [],
    loading: false,
    error: null,
  }),
  getters: {
    allHarvests: state => state.harvests,
    totalHarvests: state => state.harvests.length,
  },
  mutations: {
    setHarvests(state, data) { state.harvests = data; },
    addHarvest(state, h) { state.harvests.push(h); },
    updateHarvest(state, h) {
      const i = state.harvests.findIndex(x => x.id === h.id);
      if(i !== -1) state.harvests.splice(i, 1, h);
    },
    removeHarvest(state, id) { state.harvests = state.harvests.filter(h => h.id !== id); },
    setLoading(state, loading) { state.loading = loading; },
    setError(state, error) { state.error = error; },
  },
  actions: {
    async fetchHarvests({ commit }) {
      commit('setLoading', true);
      try {
        const data = await new Promise(resolve =>
          setTimeout(() => resolve([{ id:1, crop:'Maize', amount:'200 bags' }, { id:2, crop:'Wheat', amount:'150 bags' }]), 500)
        );
        commit('setHarvests', data);
      } catch(err){ commit('setError', err.message); }
      finally { commit('setLoading', false); }
    },
    async addHarvest({ commit }, h) { commit('addHarvest', { ...h, id: Date.now() }); },
    async updateHarvestAction({ commit }, h) { commit('updateHarvest', h); },
    async deleteHarvest({ commit }, id) { commit('removeHarvest', id); },
  },
};
